import React from 'react'
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom'

import Home from './containers/Home/Home'
import Browse from './containers/Browse/Browse'
import ViewAsset from './containers/ViewAsset/ViewAsset'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import TqlBuilder from './containers/TqlBuilder/TqlBuilder'
import NotFound from './components/NotFound/NotFound'

const PageWrapper = (WrappedComponent) => (props) => {
    return (
        <div>
            <Header />
            <WrappedComponent />
            <Footer />
        </div>
)}

const routes = [
    {
        path: '/',
        exact: true,
        main: PageWrapper(Home)
    },
    {
        path: '/browse',
        main: PageWrapper(Browse)
    },
    {
        path: '/asset/:tid',
        main: PageWrapper(ViewAsset)
    },
    {
        path: '/tqlbuilder',
        main: PageWrapper(TqlBuilder)
    }
]

const Routes = (props) => (
    <Router>
        <div>
            <Switch>
                {routes.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.main}
                    />
                ))}
                <Route component={PageWrapper(NotFound)} />
            </Switch>
        </div>
    </Router>
)

export default Routes



// WEBPACK FOOTER //
// ./src/routes.js